import React from 'react';
import { isAuthorized } from '@Service/authentication';
import { Logo } from '@Components/logo';

/**
 * Higher order component that should be used whenever a component is permission based. I.e. when a component
 * only should be rendered when a user has a certain permission or has access to specific labels
 *
 */

/**
 * @example Example usage of component that should only be rendered when user has a certain permission
 * Shows a link that is only visible when the user has permission
 * <Authorize user={currentUser} permissions={Permission}>
 * ...here render the component to show...
 * </Authorize>
 */
export const Authorize = ({ permissions, user, labels, children }) => {
    if (isAuthorized(user, permissions, labels)) {
        return children;
    }
    return null;
};

/**
 * NotAuthorizedPage renders if the currentUser don't have the right permissions to view a page.
 */
export const NotAuthorizedPage = () => (
    <div style={{ textAlign: 'center' }}>
        <Logo />
        <h3>Sorry, you do not have access to this information</h3>
        <p style={{ whiteSpace: 'pre-wrap' }}>
            You do not have sufficient access rights to view this. Try logging in as another user if
            you need to view this.
        </p>
    </div>
);

/**
 * @example Example usage of a page that should only be visible to a user with a certain permission
 * A page visible if user has permission CLAUSE_READ otherwise a default
 * <AuthorizePage user={currentUser} permissions={[permissions.CLAUSE_READ]}>
 * ...here the actual page is rendered...
 * </AuthorizePage>
 */
export const AuthorizePage = ({ havePermission, children }) => {
    if (havePermission) {
        return children;
    }

    return <NotAuthorizedPage />;
};
